import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

let nextId = 0;

/** The same outlined Material menu used by the merchandising rule editor. */
export default function AdvancedRuleSelect({
  label,
  value,
  options,
  onChange,
  disabled = false,
}) {
  const [id] = useState(() => `mp-rule-select-${++nextId}`);
  return (
    <FormControl
      variant="outlined"
      size="small"
      className="mp-rule-select"
      fullWidth
      disabled={disabled}
    >
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        id={id}
        labelId={`${id}-label`}
        label={label}
        value={options.some(option => option.value === value) ? value : ''}
        onChange={event => onChange(event.target.value)}
        MenuProps={{
          classes: { paper: 'mp-rule-select-menu' },
          getContentAnchorEl: null,
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
        }}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
